export default __webpack_public_path__ + "figure_with_monoscope.718f52aa.png";